import React from "react";
import styles from "./Whyimporc.module.css";

const WhyimporcAuthor = () => {
  return (
    <div className={styles.blueBorderBlock}>
      <div className={styles.heading}>
        <h4>Benefits of Research Associates</h4>
      </div>
      <div className={styles.content}>
        <ol type="1">
          <li>
            Free access to the IMPARC Knowledge Series—webinars, conferences,
            and academic events.
          </li>
          <li>First paper publication is absolutely free.</li>
          <li>
            Enjoy exclusive discounts on future publications, event
            participation, conference registrations, and publishing services.
          </li>
          <li>
            Earn certificates and actively participate as a presenter,
            moderator, or reviewer.
          </li>
          <li>Enjoy a 20% referral reward for successful referrals.</li>
          <li>
            Benefit from priority indexing and fast DOI allocation for your
            work.
          </li>
          <li>
            Gain featured exposure through Author Spotlight and promotional
            activities.
          </li>
          <li>
            Expand your network and knowledge through networking and
            collaborations.
          </li>
          <li>
            Comprehensive research support: free expert consultation, writing
            guidance, data analysis, proofreading, and editing.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default WhyimporcAuthor;
